import { render, staticRenderFns } from "./PEC_lunBo3.vue?vue&type=template&id=647c1c1a"
import script from "./PEC_lunBo3.vue?vue&type=script&lang=js"
export * from "./PEC_lunBo3.vue?vue&type=script&lang=js"
import style0 from "./PEC_lunBo3.vue?vue&type=style&index=0&id=647c1c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports